/* ============================================================
   BIBERKO — recenzije: filteri, sortiranje, lightbox, forma.
   Bez biblioteka. Delegacija na document.
   ============================================================ */
(function () {
  'use strict';
  if (window.__biberkoReviewsInit) return;
  window.__biberkoReviewsInit = true;

  var doc = document;
  var lbImages = [];
  var lbIndex = 0;

  function root() { return doc.querySelector('[data-bibr]'); }

  /* ---------- demo chip uz rating u buy boxu ---------- */
  function markDemoRating() {
    var section = root();
    if (!section || section.getAttribute('data-bibr-demo') !== 'true') return;
    var rating = doc.querySelector('.bibp-rating');
    if (!rating || rating.querySelector('.bibp-rating__demo')) return;
    var chip = doc.createElement('span');
    chip.className = 'bibp-rating__demo';
    chip.textContent = 'demo';
    rating.appendChild(chip);
  }

  /* ---------- filteri + sortiranje ---------- */
  function apply() {
    var section = root();
    if (!section) return;
    var grid = section.querySelector('[data-bibr-grid]');
    if (!grid) return;

    var activeChip = section.querySelector('.bibr__chip.is-active');
    var filter = activeChip ? activeChip.getAttribute('data-filter') : 'all';
    var sortSelect = section.querySelector('[data-bibr-sort]');
    var sort = sortSelect ? sortSelect.value : 'newest';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bibr-card'));
    var visible = 0;

    cards.forEach(function (card) {
      var rating = card.getAttribute('data-rating');
      var photo = card.getAttribute('data-photo') === 'true';
      var ok = true;
      if (filter === 'photo') ok = photo;
      else if (filter !== 'all') ok = rating === filter;
      card.hidden = !ok;
      if (ok) visible++;
    });

    cards.sort(function (a, b) {
      if (sort === 'rating') return Number(b.getAttribute('data-rating')) - Number(a.getAttribute('data-rating'));
      if (sort === 'helpful') return Number(b.getAttribute('data-helpful')) - Number(a.getAttribute('data-helpful'));
      return String(b.getAttribute('data-date')).localeCompare(String(a.getAttribute('data-date')));
    });
    cards.forEach(function (card) { grid.appendChild(card); });

    var empty = section.querySelector('[data-bibr-empty]');
    if (empty) empty.hidden = visible > 0;
  }

  doc.addEventListener('click', function (event) {
    var chip = event.target.closest('.bibr__chip');
    if (chip) {
      var section = chip.closest('[data-bibr]');
      section.querySelectorAll('.bibr__chip').forEach(function (el) { el.classList.remove('is-active'); });
      chip.classList.add('is-active');
      apply();
      return;
    }

    var toggle = event.target.closest('[data-bibr-write]');
    if (toggle) {
      var form = doc.querySelector('[data-bibr-form]');
      if (form) {
        form.hidden = !form.hidden;
        if (!form.hidden) {
          var first = form.querySelector('input, textarea');
          if (first) first.focus();
        }
      }
      return;
    }

    var thumb = event.target.closest('[data-bibr-lb]');
    if (thumb) {
      openLightbox(thumb.getAttribute('data-bibr-lb'));
      return;
    }

    if (event.target.closest('[data-bibr-lb-close]') || event.target.closest('.bibr-lb__scrim')) {
      closeLightbox();
      return;
    }
    if (event.target.closest('[data-bibr-lb-prev]')) { step(-1); return; }
    if (event.target.closest('[data-bibr-lb-next]')) { step(1); return; }
  });

  doc.addEventListener('change', function (event) {
    if (event.target.matches('[data-bibr-sort]')) apply();
  });

  /* ---------- lightbox ---------- */
  function collect() {
    lbImages = Array.prototype.slice.call(doc.querySelectorAll('[data-bibr-lb]')).map(function (el) {
      return el.getAttribute('data-bibr-lb');
    });
  }

  function render() {
    var box = doc.querySelector('[data-bibr-lightbox]');
    if (!box) return;
    var img = box.querySelector('img');
    if (img) img.setAttribute('src', lbImages[lbIndex]);
  }

  function openLightbox(src) {
    collect();
    var box = doc.querySelector('[data-bibr-lightbox]');
    if (!box) return;
    lbIndex = Math.max(0, lbImages.indexOf(src));
    render();
    box.classList.add('is-open');
    doc.documentElement.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var box = doc.querySelector('[data-bibr-lightbox]');
    if (!box) return;
    box.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
  }

  function step(delta) {
    if (!lbImages.length) return;
    lbIndex = (lbIndex + delta + lbImages.length) % lbImages.length;
    render();
  }

  doc.addEventListener('keydown', function (event) {
    var box = doc.querySelector('[data-bibr-lightbox].is-open');
    if (!box) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });

  /* ---------- forma (UI, bez backenda) ---------- */
  doc.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bibr-form]');
    if (!form) return;
    event.preventDefault();
    var msg = form.querySelector('[data-bibr-msg]');
    if (msg) {
      msg.hidden = false;
      msg.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });

  function init() {
    markDemoRating();
    apply();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  doc.addEventListener('shopify:section:load', init);
})();
